import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class KaiziqResolveConnectionService {

    constructor() {
        
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.KAIZIQ_RESOLVE = '/api/kaiziq-resolve';
        this.KAIZIQ_RESOLVE_EXPAND = '/api/kaiziq-resolve-expand';
    
        this.GET_LIST_FILTERED = '/list/filtered';
        this.GET_BY_ID = '/{id}';
        this.GET_BY_FORM_ID = '/formId/{formId}';
        this.GET_LIST_FOR_PROJECT = '/list/project/{projectId}';
        this.GET_LIST_FOR_PROJECT_AND_ASSIGNEE = '/list/project/{projectId}/{assigneeUserId}';
        this.UPDATE_PHOTO = '/update/photo';
        this.UPDATE_TITLE = '/update/title';
        this.UPDATE_DETAILS = '/update/details';
        this.UPDATE_CONNECTION_LIVE = '/update/live-connection';
	}

	async getKaiziqResolveConnectionById(id) {
		let url = window.location.origin + this.KAIZIQ_RESOLVE_EXPAND + this.GET_BY_ID;
		url = url
			.replace('{id}', id);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}

	async getKaiziqResolveConnectionByFormId(formId) {
		let url = window.location.origin + this.KAIZIQ_RESOLVE_EXPAND + this.GET_BY_FORM_ID;
		url = url
			.replace('{formId}', formId);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}

    async getKaiziqResolveConnectionListByProject(projectId) {
		let url = window.location.origin + this.KAIZIQ_RESOLVE_EXPAND + this.GET_LIST_FOR_PROJECT;
		url = url
			.replace('{projectId}', projectId);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}

    async getKaiziqResolveConnectionListByProjectAndAssignee(projectId, assigneeUserId) {
		let url = window.location.origin + this.KAIZIQ_RESOLVE + this.GET_LIST_FOR_PROJECT_AND_ASSIGNEE;
		url = url
			.replace('{projectId}', projectId)
			.replace('{assigneeUserId}', assigneeUserId);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}

    async getListFiltered(filterRequest) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_RESOLVE_EXPAND + this.GET_LIST_FILTERED;
        try {
            return fetch(url, {
                method: 'POST',
                headers: {
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(filterRequest)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async createKaiziqResolveConnection(kaiziqResolveConnection) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_RESOLVE;
        try {
            return fetch(url, {
                method: 'POST',
                headers: {
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(kaiziqResolveConnection)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async updateKaiziqResolveConnectionTitle(kaiziqResolveConnectionId, newTitle) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_RESOLVE + this.UPDATE_TITLE;
        let body = {
            id: kaiziqResolveConnectionId,
            title: newTitle
        }
        try {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async updateKaiziqResolveConnectionPhoto(kaiziqResolveConnectionId, photo) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_RESOLVE + this.UPDATE_PHOTO;
        let body = {
            id: kaiziqResolveConnectionId,
            photo: photo
        }
        try {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async updateKaiziqResolveConnectionDetails(kaiziqResolveConnectionId, newDetails) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_RESOLVE + this.UPDATE_DETAILS;
        let body = {
            id: kaiziqResolveConnectionId,
            details: newDetails
        }
        try {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async updateKaiziqResolveConnectionConnectionLive(kaiziqResolveConnectionId, isLiveConnection) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_RESOLVE + this.UPDATE_CONNECTION_LIVE;
        let body = {
            id: kaiziqResolveConnectionId,
            connectionLive: isLiveConnection
        }
        try {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch (err) {
            console.log(err)
        }
    }

    async deleteKaiziqResolveConnection(kaiziqResolveConnectionId){
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_RESOLVE;
        let body = {
            'id': kaiziqResolveConnectionId
        };
        try {
            const dataRet = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return dataRet;
        } catch (err) {
            console.log(err);
        }
   }
}

export default KaiziqResolveConnectionService;